angular.module 'app'
.config ($stateProvider) ->
  $stateProvider
    # 粉絲管理
    .state 'app.fans',
      url: '/fans'
      templateUrl: 'apps/fans/fans'
      controller: 'FansCtrl'
      resolve:
        loadPlugin: ($ocLazyLoad) ->
          $ocLazyLoad.load([
              name: 'css'
              insertAfter: '#app-level'
              files: [
                'bootstrap-daterangepicker/daterangepicker.css'
              ]
            ,
              name: 'vendors'
              insertAfter: '#app-level-js'
              files: [
                'jqueryFileDownload/jquery.fileDownload.js'
                'bootstrap-daterangepicker/daterangepicker.js'
              ]
          ])
    # 測試
    .state 'app.fansTest',
      url: '/fansTest'
      templateUrl: 'apps/fans/fansTest'
      controller: 'FansTestCtrl'
      resolve:
        loadPlugin: ($ocLazyLoad) ->
          $ocLazyLoad.load([
              name: 'css'
              insertAfter: '#app-level'
              files: [
                'bootstrap-daterangepicker/daterangepicker.css'
              ]
            ,
              name: 'vendors'
              insertAfter: '#app-level-js'
              files: [
                'jqueryFileDownload/jquery.fileDownload.js'
                'bootstrap-daterangepicker/daterangepicker.js'
              ]
          ])